import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwCheckboxBuilder extends Component {
  @tracked size = 'm';
  @tracked label = 'Checkbox label';
  @tracked sublabel = 'Checkbox sublabel';
  @tracked checked = false;
  @tracked disabled = false;
  sizeOptions = ["s","m","l"];

  @action
  setSize(value) {
    this['size'] = value;
  }

  @action
  setLabel(event) {
    this['label'] = event.target.value;
  }

  @action
  setSublabel(event) {
    this['sublabel'] = event.target.value;
  }

  @action
  setChecked(value) {
    this['checked'] = value;
  }

  @action
  setDisabled(value) {
    this['disabled'] = value;
  }

  @action
  resetToDefaults() {
    this['size'] = 'm';
    this['label'] = 'Checkbox label';
    this['sublabel'] = 'Checkbox sublabel';
    this['checked'] = false;
    this['disabled'] = false;
  }
}
